<template>
  <div>
    <h1 class="header-style">
      Worker <br>Check-in
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-in.
    </p>
    <v-stepper
      v-if="orgSettings.questionnaire_verification"
      v-model="userCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckIn > 1"
          step="1"
          color="#37474F"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 2"
          step="2"
          color="#37474F"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 3"
          color="#37474F"
          step="3"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 4"
          color="#37474F"
          step="4"
        />
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      v-if="!orgSettings.questionnaire_verification"
      v-model="userCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckIn > 1"
          step="1"
          color="#000"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 2"
          step="2"
          color="#000"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <worker-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <gather-work-details
        v-if="showWorkDetailsPage"
        @work-details-stored="toThirdStep"
      />
      <worker-questions
        v-if="showQuestionsPage"
        @questions-answered="toFourthStep"
      />
      <review-work-details
        v-if="showWorkReviewPage"
        @checkin-completed="checkInCompleted"
      />
    </div>
  </div>
</template>

<script>
  import WorkerLocationVerification from '../dialogComponents/WorkerDialogs/checkin/WorkerLocationVerification.vue';
  import GatherWorkDetails from '../dialogComponents/WorkerDialogs/checkin/GatherWorkDetails.vue';
  import WorkerQandA from '../dialogComponents/WorkerDialogs/checkin/WorkerQandA.vue';
  import ReviewWorkDetails from '../dialogComponents/WorkerDialogs/checkin/ReviewWorkDetails.vue';
  export default {
    name: 'WorkerCheckInPage',
    components: {
      'worker-location-verification': WorkerLocationVerification,
      'gather-work-details': GatherWorkDetails,
      'worker-questions': WorkerQandA,
      'review-work-details': ReviewWorkDetails,
    },
    data () {
      return {
        userCheckIn: 1,
        showLocationVerificationPage: false,
        step1SuccessColor: '',
        showWorkDetailsPage: false,
        step2SuccessColor: '',
        showQuestionsPage: false,
        step3SuccessColor: '',
        showWorkReviewPage: false,
        isLocationEnabled: true,
      };
    },
    computed: {
      checkInMethodType () {
        return this.$store.getters['swiftuser/getCheckInMethodType'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    mounted () {
      this.loadOnMount();
      this.fetchOrgDetails();
      this.checkSettingsLocation();
    },
    methods: {
      checkSettingsLocation () {
        this.userCheckIn = 1;
        this.showLocationVerificationPage = true;
        this.showWorkDetailsPage = false;
        this.isLocationEnabled = false;
      },
      checkSettingsQuestionnaire () {
        if (!this.orgSettings.questionnaire_verification) {
          this.showQuestionsPage = false;
          this.showWorkReviewPage = true;
          this.userCheckIn = 3;
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.selectedOrganization);
      },
      loadOnMount () {
        if (this.checkInMethodType === null || Object.keys(this.selectedOrganization).length === 0) {
          this.$router.push({ name: 'CheckIn' });
        }
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.userCheckIn = 2;
        this.showLocationVerificationPage = false;
        this.showQuestionsPage = false;
        this.showWorkReviewPage = false;
        this.showWorkDetailsPage = true;
      },
      toThirdStep () {
        this.step2SuccessColor = '#00796B';
        this.userCheckIn = 3;
        this.showLocationVerificationPage = false;
        this.showWorkReviewPage = false;
        this.showWorkDetailsPage = false;
        this.showQuestionsPage = true;
        this.checkSettingsQuestionnaire();
      },
      toFourthStep () {
        this.step3SuccessColor = '#00796B';
        this.userCheckIn = 4;
        this.showLocationVerificationPage = false;
        this.showReviewJobPage = false;
        this.showWorkDetailsPage = false;
        this.showQuestionsPage = false;
        this.showWorkReviewPage = true;
      },
      checkInCompleted () {
        this.$router.push({ name: 'Checkin Success' });
      },
    },
  };
</script>
